const zh = {
  // 操作
  addProduct: "添加商品",

  code: "存货编码",
  name: "存货名称",
  uom: "主计量单位",
  cbm: "立方米",
  brand1: "型号1",
  brand2: "型号2",

  // 表单
  plCode: '请输入存货编码',
  plCodeRule: "存货编码长度最少为{{min}}位，最多为{{max}}位。",
  plName: '请输入存货名称',
  plInputMaxRule: "存货名称最多不超过{{length}}个字。",
  plCbm: "请输入立方米",
  plDesc: "请输入描述",
  plBrand1: "请输入型号1",
  plBrand2: "请输入型号2",
  plUom: '请选择主计量单位',

  category: "所属类目",
  addFailed: "添加失败",
  modifySuccess: "修改成功",
  modifyFailed: "修改失败",
  addChildNode: "添加子节点",
  clickModify: "点击修改",
  serialNum: "序号",
  addCategory: "添加分类",
  addType: "添加商品种类",
  selProduct: "请选择商品",
  priPrducInfo: "打印商品信息",
  priThisPage: "打印该页内容",
  modify: "修改",
  plFill: "请填写必填项！",
  modifyProduct: "修改商品",
  process: "工序",
  processPl: "请选择工序",
  materialProcess: "物料制程",
  cbmDecimalLength: "小数位数不能超过{{count}}位",

  gallery: '图库',
  folder: '资料夹',
  dataError: '数据错误，请联系管理员修改资料后再试',
  productInfo: '产品信息',

  num: '存货数量',
  model: '存货型号',
  preReady: '常备物料',
  isTrue: '是',
  isFalse: '否',
  isDeprecated: '是否废弃',
  deprecated: '废弃',
  normalStatus: '正常',
  notSet: '未设定',
  returnQuantity: "退库数量",
  noReturnQuantity: "没有退货商品",

  // 生产资料
  createProductInfo: "创建生产资料",
  editProductInfo: "编辑生产资料",
  viewProductInfo: "查看生产资料",
  selectSaleOrder: "选择销售订单",
  orderNumber: "订单号",
  erpCode: "ERP料号",
  issueDate: "发行日期",
  customerName: "客户名称",
  customerModel: "客户型号",
  companyModel: "公司型号",
  productionSoftware: "生产软件",
  flash: "Flash",
  md5Value: "MD5值",
  checksum: "校验和",
  qaToolVersion: "QA工具版本",
  softwareVersion: "软件版本",
  macAddressContent: "MAC地址内容",
  quantity: "数量",
  size: "尺寸",
  antivirusStatus: "软件杀毒",
  languageRequirement: "语言要求",
  ssid: "SSID",
  initialIp: "初始IP",
  finishedToolVersion: "成品工具版本",
  semiFinishedToolVersion: "半成品工具版本",
  channelRange: "信道范围",
  channelSelection: "信道选择",
  defaultChannel: "默认信道",
  functionDescription: "功能描述",
  productionTestProgram: "生产测试程序",
  power: "功率",
  evm: "EVM",
  fer: "FER",
  smt: "SMT",
  dip: "DIP",
  test1: "测试1",
  assy: "组装",
  test2: "测试2",
  pack: "包装",
  shipmentRequirements: "发货要求",
  plSelectSaleOrder: "请选择销售订单",
  attachments: "附件图片",
  uploadImage: "上传图片",
  plUploadImage: "请上传图片",
  uploadFailed: "上传失败",
  imageSelected: "已选择图片",
  onlyImageAllowed: "只允许上传图片",
  clickOrDragUpload: "点击或拖动文件到此区域上传",
  descriptionPlaceholder: "描述（可选）",
  addAttachment: "添加附件图片",
  languageZh: "中",
  languageEn: "英",
  languageTr: "繁",
  languageVn: "越南语",
  languageKo: "韩",
  languageFr: "法",
  languageDe: "德",
  languageRu: "俄",
  languageAdaptive: "自适应",
  languagePortuguese: "葡萄牙，其他",
  region36to165: "区域36-165",
  basicInfo: "基本信息",
  productionInfo: "生产信息",
  testInfo: "测试信息",
  shipmentInfo: "发货信息",
  delete: "删除",
  basicInfoDesc: "基本资料说明",
  testProgram: "产测程序",
  testProgramFinished: "产测程序-成品工具版本",
  testProgramSemiFinished: "产测程序-半成品工具版本",
  auto: "自动",
  addSuccess: "创建成功",
  addSuccessDesc: "生产资料已成功创建",
  editSuccess: "更新成功",
  editSuccessDesc: "生产资料已成功更新",
  editFailed: "更新失败",
  saleOrderAlreadyHasProductInfo: "销售单号：{{orderNumber}}，已创建生产资料",

  // 列表页面
  normalTab: "正常",
  disabledTab: "禁用",
  salesOrderNumber: "销售订单号",
  internalNumber: "内部单号",
  createdAt: "创建时间",
  updatedAt: "更新时间",
  action: "操作",
  disable: "禁用",
  enable: "启用",
  disableConfirm: "禁用确认",
  enableConfirm: "启用确认",
  disableConfirmDesc: "确定要禁用生产资料吗？",
  enableConfirmDesc: "确定要启用生产资料吗？",
  disableSuccess: "禁用成功",
  enableSuccess: "启用成功",
  disableFailed: "禁用失败",
  enableFailed: "启用失败",
  searchPlaceholder: "请输入产品ID或说明书名称搜索",
  batchExport: "批量导出",
  minStockCount: "最小库存",
  maxStockCount: "最大库存",
  minStockAgeDays: "最小库龄(天)",
  maxStockAgeDays: "最大库龄(天)",
  codePl: "输入料号",
  alertAdd: "添加预警信息",
  alertDetail: "预警信息",
  overMaxCount: "超出库存上限：{{maxStockCount}}",
  lowerMinCount: "低于库存下限：{{minStockCount}}",
  alert: "预警",
  hh: "恒湿",
  ht: "恒温",
  va: "真空",
  ot: "其他",
  storeType: "存储要求",
  storageCode: "要求类型",
  minValue: "下限",
  maxValue: "上限",
  unit: "单位",
  inspectionCycleDays: "巡检周期(天)",
};

export default zh;
